/**
 * then (optionally) convert inner h3 headings to p for SEO hierarchy.
 */
document.addEventListener( 'DOMContentLoaded', () => {
  const section = document.querySelector( 'section.e-stn--focus-scroll-with-light-and-dark-theme' );
  if ( !section ) return;
  
  const headings = section.querySelectorAll( '.e-acc__itm-hdr h3' );
  
  headings.forEach( h3 => {
    const p = document.createElement( 'p' );
    p.className = h3.className; // copy classes
    p.innerHTML = h3.innerHTML; // copy inner content
    h3.replaceWith( p ); // replace h3 with p
  } );
} );

